import { TDateTimeMode } from "../../types";
import {
	ISummaryCardProps,
	TColumn,
	TDataListComponentType,
} from "./SummaryCard.fixtures";
import { Tile } from "./Tile";
import TileWithOperator from "./TileWithOperator";

const TODAY = "TODAY";

const handleSpecificData = (
	data: object,
	type: TDataListComponentType,
	columns: TColumn[],
	timeMode: TDateTimeMode
) => {
	let dynamicallyComparedKey;

	if (type === "production_overview") {
		const variance = columns.find((col) => col.prop === "variance");
		const trend = columns.find((col) => col.prop === "trend");

		if (timeMode === TODAY) {
			dynamicallyComparedKey = variance?.dynamic_attribute1;
			trend &&
				(data[trend.threshold] = Math.round(
					parseFloat(data[trend.threshold])
				));
		} else {
			dynamicallyComparedKey = variance?.dynamic_attribute2;
			columns
				.filter((col) => !col.past_visibility)
				.forEach((key) => {
					data[key.prop] = "--";
					if (key.hasOwnProperty("threshold")) {
						data[key.threshold] = "--";
					}
				});
		}

		variance &&
			(data[variance.prop] =
				data[variance.compared_attribute] -
				data[dynamicallyComparedKey]);
	}
	return { data, dynamicallyComparedKey };
};

const dataProcessing = (
	data: object,
	type: TDataListComponentType,
	columns: TColumn[],
	timeMode: TDateTimeMode
) => {
	if (type === "production_overview") {
		for (let i = 0; i < columns.length; i++) {
			if (
				data.hasOwnProperty(columns[i].prop) &&
				columns[i].prop !== "production_hour"
			) {
				data[columns[i].prop] = Math.round(
					parseFloat(data[columns[i].prop])
				);
			}
		}
	}

	return handleSpecificData(data, type, columns, timeMode);
};

export const SummaryCard = ({
	componentInfo: { config, data },
	timeMode,
}: ISummaryCardProps) => {
	const summaryData = data?.data?.[0] || {};
	const { type, columns, operators } = config.args.options;
	const processedData = dataProcessing(summaryData, type, columns, timeMode);
	const isTodayView = timeMode === TODAY;
	const columnLength = columns.length;

	const resolveColumnView = (col: TColumn) => {
		return col.daily_view && isTodayView
			? col.daily_view
			: col.standard_view;
	};

	const columnVisibiltyByTimeMode = (col: TColumn) =>
		isTodayView || col.past_visibility;

	const getClass = (col: TColumn, index: number) => {
		switch (resolveColumnView(col)) {
			case "HEADER":
				return `title zf-padding-r-xxxl mobile-view-100 ${
					!index ? "" : "col-flex-center"
				}`;
			case "NORMAL":
			case "OPERATOR_PREFIX":
				return "mobile-view-100 ";
			case "NO_OPERATOR":
				return "padding-20 mobile-view-100 ";
			default:
				break;
		}
	};

	return (
		<div className="info-card align-item">
			{!operators &&
				columns.map((tile) => {
					return (
						<div
							className="tile__flex-width"
							key={tile.name + "tile"}
						>
							<Tile
								key={tile.name}
								column={tile}
								data={processedData.data}
								dynamicallyComparedKey={
									processedData.dynamicallyComparedKey
								}
								timeMode={timeMode}
							/>
						</div>
					);
				})}

			{operators &&
				columns.map((tile, index) => {
					return (
						columnVisibiltyByTimeMode(tile) && (
							<div
								className={`${getClass(tile, index)} ${
									index === columnLength - 1
										? "equal-background zf-margin-t-xxl-m"
										: ""
								}
								column-wrapper col__align-start`}
							>
								<TileWithOperator
									key={tile.name}
									column={tile}
									data={processedData.data}
									dynamicallyComparedKey={
										processedData.dynamicallyComparedKey
									}
									timeMode={timeMode}
								/>
							</div>
						)
					);
				})}
		</div>
	);
};

export default SummaryCard;
